import { CENTER_DEFAULT } from '@/configuration/general/carteConf';

export default function defineCenter(markers, centreDefault) {
  const allLatitude = [];
  const allLongitude = [];
  if (!markers || markers.length === 0) {
    if (centreDefault) {
      return centreDefault;
    }
    return CENTER_DEFAULT;
  }
  markers.forEach((marker) => {
    allLatitude.push(marker.position.lat);
    allLongitude.push(marker.position.lng);
  });
  const minLatitude = Math.min(...allLatitude);
  const minLongitude = Math.min(...allLongitude);
  const maxLatitude = Math.max(...allLatitude);
  const maxLongitude = Math.max(...allLongitude);
  return {
    lat: minLatitude + (maxLatitude - minLatitude) / 2,
    lng: minLongitude + (maxLongitude - minLongitude) / 2,
  };
}
